// helper to redirect to login page if user is not authenticated

import { jwtDecode } from "jwt-decode";
import { refreshAdminToken } from "./authHelper";
import { msalInstance } from "../index";

export const fetchWithAuth = async (
  url: string,
  options: RequestInit = {},
): Promise<Response> => {
  let token = localStorage.getItem("token");

  if (!token) {
    console.log("No token found, redirecting to login");
    localStorage.clear();
    window.location.href = "/login";
    throw new Error("User is not authenticated");
  }

  try {
    const decodedToken: any = jwtDecode(token);
    const issuer = decodedToken.iss || "";
    const isMicrosoftToken = issuer.includes("login.microsoftonline.com");
    const isAdmin = decodedToken.roles?.includes("Admin");

    if (decodedToken.exp * 1000 < Date.now()) {
      if (isMicrosoftToken && isAdmin) {
        try {
          token = await refreshAdminToken(msalInstance);
          if (!token) {
            throw new Error("Token refresh failed.");
          }
        } catch (refreshError) {
          console.error("Silent token renewal failed:", refreshError);
          localStorage.clear();
          window.location.href = "/login";
          throw new Error("Silent renewal failed: Redirecting to login");
        }
      } else {
        localStorage.clear();
        window.location.href = "/login";
        throw new Error("Token expired: Redirecting to login");
      }
    }
  } catch (error) {
    console.error("Error decoding token:", error);
    localStorage.clear();
    window.location.href = "/login";
    throw new Error("Token is invalid: Redirecting to login");
  }

  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await fetch(url, { ...options, headers });

    // Handle 401 Unauthorized error here
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      throw new Error("Unauthorized: Redirecting to login");
    }

    return response;
  } catch (error) {
    console.error("Error occurred during fetch:", error);
    throw error;
  }
};
